import { enumMarginMethod } from '@nxsys/constants/AppEnums';

/**
 * Margin methods whose amount comes from a band table (`timesheet_values`)
 * instead of the flat Margin field. Used to decide whether to offer the table
 * and to lock the flat field, for both agencies and employees.
 */
export const isTableMarginMethod = (value?: string): boolean =>
  value === enumMarginMethod.FIXED_FEE_TABLE ||
  value === enumMarginMethod.PERCENT_TABLE_ON_TIMESHEET_VALUE;
